"use client";

import styled from "styled-components";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

export const Modal = styled(Dialog)`
  margin: 2rem;
`;

export const TitleModal = styled(DialogTitle)`
  font-family: "Inter SemiBold";
  font-size: 20px;
  margin-bottom: 10px;
`;

interface ModalContentProps {
  $size?: "default" | "large" | "extra-large" | "wide";
}

export const ModalContent = styled(DialogContent)<ModalContentProps>`
  z-index: 9999;
  gap: 0;
  padding: 4px 3px;
  overflow: hidden;

  ${({ $size = "default" }) => {
    switch ($size) {
      case "large":
        return `
                max-width: 80vw;
                width: 80vw;
            `;
      case "extra-large":
        return `
                max-width: 95vw;
                width: 95vw;
            `;
      case "wide":
        return `
                width: 100%;
                max-width: 100%;
                
                @media (min-width: 768px) {
                    width: 70%;
                    max-width: 70%;
                }
            `;
      default:
        return `
                max-width: 32rem;
                width: 100%;
            `;
    }
  }}

  button {
    cursor: pointer;
    transition: 0.3s;
    &:focus {
      box-shadow: none !important;
    }
  }

  &::-webkit-scrollbar-track {
    background: var(--transparent);
  }

  &::-webkit-scrollbar {
    width: 5px;
    background: var(--transparent);
  }

  &::-webkit-scrollbar-thumb {
    width: 3px;
    border-radius: 50px;
    background: var(--textColor);
  }
`;

export const BoxContainer = styled.div`
  height: 100%;
  max-height: calc(100vh - 40px);
  min-height: 420px;
  padding: 20px 20px 20px 20px;
  overflow-y: auto;

  &::-webkit-scrollbar-track {
    background: var(--transparent);
  }

  &::-webkit-scrollbar {
    width: 5px;
    background: var(--transparent);
  }

  &::-webkit-scrollbar-thumb {
    width: 5px;
    border-radius: 50px;
    background: var(--borderColor);
  }
`;

export const ButtonModal = styled(DialogTrigger)`
  font-family: "Roboto Medium";
  font-size: 13px;
  background: var(--primarySystem);
  padding: 3px 15px;
  border-radius: calc(0.625rem - 2px);
  color: #000;
  cursor: pointer;
  transition: 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
